import { gsap, ScrollTrigger, ScrollSmoother, Power4, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, Power4, ScrollToPlugin);

// normalize ScrollTrigger?
ScrollTrigger.normalizeScroll(false); // helps prevent browser jumps for the anchor nav on mobile when scrolling 
// ScrollTrigger.config({
//     ignoreMobileResize: true,
//     // autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
// })
// create matchMedia
let mm = gsap.matchMedia();
// add a media query. When it matches, the associated function will run
mm.add("(min-width: 768px)", () => {

    // create the scrollSmoother before your scrollTriggers
    ScrollSmoother.create({
        smooth: .5,               // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true,           // looks for data-speed and data-lag attributes on elements
        // smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
        normalizeScroll: false,
    });

    // Move Location a little to left or right depending on layout
    gsap.utils.toArray("#smooth-content .special-company__location.left").forEach((company) => {

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: company,
                scrub: true,
            }
        });

        tl
            .to(company, {
                duration: .75,
                x: 20
            })
    });
    gsap.utils.toArray("#smooth-content .special-company__location.right").forEach((company2) => {

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: company2,
                scrub: true,
                // markers: true,
            }
        });

        tl
            .to(company2, {
                duration: .75,
                x: -20
            })
    });

    // ENDING WRAPPER

    return () => { // optional
        // custom cleanup code here (runs when it STOPS matching)
    };
});

// commas function for numbers
function numberWithCommas(n) {
    var parts = n.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// counting up stats
gsap.utils.toArray(".countup").forEach((countingNumber) => {

    let Cont = { val: 0 },
        NewVal = countingNumber.dataset.countup;

    gsap.to(Cont, 0.75, {
        scrollTrigger: countingNumber,
        val: NewVal,
        roundProps: "val",
        onUpdate: function () {
            countingNumber.innerText = numberWithCommas(Cont.val);
        },

    });

});

// Animated Ranking number
gsap.utils.toArray(".special-company__rank-number").forEach((rankingNumber) => {

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: rankingNumber,
            // markers: true,
            start: 'bottom bottom',
            // scrub: true,
        }
    });

    tl
        .to(rankingNumber, {
            duration: 2,
            scale: 1,
            // toggleActions: "play none none restart",
            ease:
                Power4.easeOut,
        })
});

gsap.set(".anchor-links--smoothscroll", { yPercent: -100 });

ScrollTrigger.create({
    trigger: ".anchor-links--smoothscroll",
    start: "bottom bottom",
    endTrigger: "#partner",
    end: "top bottom",
    pin: true,
    anticipatePin: 1,
    // onRefreshInit: self => main.style.paddingBottom = self.trigger.offsetHeight + "px",
    pinSpacing: false,
    // invalidateOnRefresh: true // trying this for mobile
});

// // gsap.set(".modal--smoothscroll", { yPercent: -100 });
// ScrollTrigger.create({
//     trigger: ".modal--smoothscroll",
//     start: "top 20%",
//     end: '+=1000 50%',
//     pin: true,
//     pinSpacing: false,
// });

// Creating Anchor Links for Scroll Smoother

gsap.utils.toArray('.anchor-link').forEach((btn) => {

    btn.onclick = () => {
        let panelID = btn.attributes.href.value;
        gsap.to(window, { duration: .5, scrollTo: { y: panelID, offsetY: 100 } });
    }
})


const navLinks = gsap.utils.toArray(".anchor-link-wrapper");

const panels = gsap.utils.toArray(".special-company");

panels.forEach((panel, i) => {
    let id = "#" + panel.id;
    // console.log(id);
    const anchorMenu = document.getElementById("smoothScrollAnchorLinks");
    if (anchorMenu == null) return;
    const anchorMenuWidth = anchorMenu.offsetWidth;
    const halfAnchorMenuWidth = anchorMenuWidth / 2;

    // let hasVideo = panel.querySelector('.modal--with-video');


    ScrollTrigger.create({
        trigger: id,
        start: "top 50%",


        onEnter: () => {
            navLinks.forEach((e) => {
                // console.log(navLinks[i]);
                e.classList.remove("active");
            });
            navLinks[i].classList.add("active");
            let navPosition = navLinks[i].offsetLeft;
            // console.log("navPosition: " + navPosition);
            // anchorMenu.scrollLeft(navPosition - halfAnchorMenuWidth);
            anchorMenu.scroll({
                left: navPosition - halfAnchorMenuWidth,
                top: 0,
                behavior: 'smooth'
            })

            // move it into position, centered horizontally on the screen
        },
        onEnterBack: () => {
            navLinks.forEach((e) => {
                e.classList.remove("active");
            });
            navLinks[i].classList.add("active");
            // move it into position, centered horizontally on the screen

            let navPosition = navLinks[i].offsetLeft;
            anchorMenu.scroll({
                left: navPosition - halfAnchorMenuWidth,
                top: 0,
                behavior: 'smooth'
            })
        },
    });

});

// after gravity forms submit, refresh scrolltriggers (anchor menu)

jQuery(document).bind('gform_post_render', function(){
    // refresh scrolltrigger so anchor menu stays at the bottom
    ScrollTrigger.refresh();
    // scroll to the right spot - this wont work
    // gsap.to(window, { duration: .5, scrollTo: { y: "#partner", offsetY: 100 } });
 });